import React, { useState, useEffect } from 'react';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTSwitch from 'general/components/OtherKeenComponents/KTFormControls/KTSwitch';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import bannerApi from 'api/bannerApi';
import ToastHelper from 'general/helpers/ToastHelper';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import UIHelper from 'general/helpers/UIHelper';
import AppColors from 'general/constants/AppColors';
import KTPagination, { KTPaginationColor } from 'general/components/OtherKeenComponents/KTPagination';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import DialogAddBannerCategoryView from '../../components/DialogAddBannerCategoryView';
import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import AppResource from 'general/constants/AppResource';

BannerCategoryScreen.propTypes = {};

function BannerCategoryScreen(props) {
  const [categoryList, setCategoryList] = useState([]);
  const [filter, setFilter] = useState({ page: 0, limit: 20, q: '' });
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const res = await bannerApi.getBannerCategories(filter);
      if (res && res.data) {
        setCategoryList(res.data.data || []);
        setTotalItems(res.data.total || 0);
      }
    } catch (error) {
      ToastHelper.showError('Không thể lấy danh sách danh mục banner');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, [filter]);

  const handleChangeStatus = async (row, checked) => {
    try {
      await bannerApi.updateBannerCategory(row.id, { status: checked ? 'ACTIVE' : 'INACTIVE' });
      ToastHelper.showSuccess('Cập nhật trạng thái thành công');
      fetchCategories();
    } catch (error) {
      ToastHelper.showError('Cập nhật trạng thái thất bại');
    }
  };

  const handleMoveUp = (index) => {
    if (index === 0) return;
    const newList = [...categoryList];
    const tempOrder = newList[index].displayOrder;
    newList[index].displayOrder = newList[index - 1].displayOrder;
    newList[index - 1].displayOrder = tempOrder;
    const temp = newList[index];
    newList[index] = newList[index - 1];
    newList[index - 1] = temp;
    setCategoryList(newList);
  };

  const handleMoveDown = (index) => {
    if (index === categoryList.length - 1) return;
    const newList = [...categoryList];
    const tempOrder = newList[index].displayOrder;
    newList[index].displayOrder = newList[index + 1].displayOrder;
    newList[index + 1].displayOrder = tempOrder;
    const temp = newList[index];
    newList[index] = newList[index + 1];
    newList[index + 1] = temp;
    setCategoryList(newList);
  };

  const handleSaveOrder = async () => {
    AppCustomDialogHelper.show(
      '',
      <AgencySaleDialogView
        title="Lưu thứ tự"
        contentEl={<>Bạn có chắc chắn muốn lưu thay đổi thứ tự các danh mục không?</>}
        cancelButtonText="Bỏ qua"
        confirmButtonText="Đồng ý"
        onCancel={() => AppCustomDialogHelper.hide()}
        onConfirm={async () => {
          AppCustomDialogHelper.hide();
          try {
            setLoading(true);
            const updates = categoryList.map(c => ({ id: c.id, displayOrder: c.displayOrder }));
            await bannerApi.bulkUpdateBannerCategoryOrder(updates);
            ToastHelper.showSuccess('Lưu thứ tự thành công');
            fetchCategories();
          } catch (error) {
            ToastHelper.showError('Lưu thứ tự thất bại');
            setLoading(false);
          }
        }}
        iconEl={<img src={AppResource.images.dialogIcons.dialogSuccess} />}
      />,
      'md', true, true
    );
  };

  const buildMoreActions = (row, index) => {
    return [
      {
        text: 'Lên trên',
        iconElement: <i className="fa-solid fa-arrow-up" style={{ fontSize: '1.1rem' }} />,
        click: () => handleMoveUp(index),
      },
      {
        text: 'Xuống dưới',
        iconElement: <i className="fa-solid fa-arrow-down" style={{ fontSize: '1.1rem' }} />,
        click: () => handleMoveDown(index),
      },
      {
        text: 'Chỉnh sửa',
        iconElement: <i className="fa-regular fa-edit" style={{ fontSize: '1.1rem' }} />,
        click: () => {
          AppCustomDialogHelper.show(
            'Chỉnh sửa danh mục',
            <DialogAddBannerCategoryView
              category={row}
              onCancel={() => AppCustomDialogHelper.hide()}
              onDone={() => {
                AppCustomDialogHelper.hide();
                fetchCategories();
              }}
            />,
            'md',
            false,
            true,
            false,
            false
          );
        },
      },
      {
        text: 'Xóa',
        iconElement: <i className="fa-regular fa-trash-can" style={{ fontSize: '1.1rem' }} />,
        click: () => {
          AppCustomDialogHelper.show(
            '',
            <AgencySaleDialogView
              title="Xóa danh mục"
              contentEl={<>Xóa danh mục "{row.name}"? Bạn có chắc chắn muốn xóa không?</>}
              cancelButtonText="Bỏ qua"
              confirmButtonText="Xóa"
              confirmButtonRed={true}
              onCancel={() => AppCustomDialogHelper.hide()}
              onConfirm={() => {
                AppCustomDialogHelper.hide();
                bannerApi.deleteBannerCategory(row.id).then(() => {
                  ToastHelper.showSuccess('Xóa danh mục thành công');
                  fetchCategories();
                }).catch(() => {
                  ToastHelper.showError('Xóa danh mục thất bại');
                });
              }}
              iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            />,
            'md', true, true
          );
        },
      },
    ];
  };
  const handleAddNew = () => {
    AppCustomDialogHelper.show(
      'Thêm mới danh mục',
      <DialogAddBannerCategoryView
        onCancel={() => AppCustomDialogHelper.hide()}
        onDone={() => {
          AppCustomDialogHelper.hide();
          fetchCategories();
        }}
      />,
      'md',
      false,
      true,
      false, // canClickOutsideToDismiss
      false  // keyboard
    );
  };

  const columns = [
    {
      id: 'NAME',
      name: UIHelper.buildTableColumn('Tên Danh mục'),
      selector: (row) => row.name,
      minWidth: '200px',
      style: tableStyle.columns.normal,
    },
    {
      id: 'DESCRIPTION',
      name: UIHelper.buildTableColumn('Mô tả'),
      selector: (row) => row.description,
      minWidth: '200px',
      style: tableStyle.columns.normal,
    },

    {
      name: UIHelper.buildTableColumn('Thao tác'),
      minWidth: '160px',
      maxWidth: '180px',
      style: {
        position: 'sticky',
        right: 0,
        backgroundColor: '#fff',
        borderLeft: '1px solid #ebedfe',
      },
      cell: (row, index) => {
        return UIHelper.buildMoreActionsButton(buildMoreActions(row, index), true, false, 4);
      },
    },
  ];

  return (
    <div className="container-fluid px-4 my-4">
      {UIHelper.buildCard(
        <div>
          <div className="pb-4">
            {/* header */}
            <div className="px-4 pt-4 pb-4 d-flex align-items-center justify-content-between">
              {/* title */}
              <div className="d-flex flex-column">
                <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                  Danh mục Banner
                </span>
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  Tổng:{' '}
                  <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                    {totalItems} danh mục
                  </span>
                </span>
              </div>

              {/* actions */}
              <div className="d-flex gap-2">
                {UIHelper.buildGreenButton(
                  'Lưu thứ tự',
                  handleSaveOrder,
                  <i className="fa-regular fa-floppy-disk" />
                )}
                {UIHelper.buildBlueButton(
                  'Thêm danh mục',
                  handleAddNew,
                  <i className="fa-regular fa-circle-plus" />
                )}
              </div>
            </div>

            {/* filter */}
            <div className="row m-0 p-0 px-2">
              <div className="col-3 mb-4 px-2">
                {UIHelper.buildFormLabel('Tìm kiếm')}
                <KTFormSearch
                  name="search"
                  placeholder="Theo tên danh mục"
                  value={filter.q || ''}
                  onSubmit={(text) => {
                    setFilter({ ...filter, q: text, page: 0 });
                  }}
                />
              </div>
            </div>

            {/* table */}
            <div>
              <div className="px-4">
                <KTTable
                  columns={columns}
                  items={categoryList}
                  selectableRows={false}
                  striped={false}
                  compactGrid={false}
                  progressPending={loading}
                  noDataComponent={UIHelper.buildEmptyNoData(
                    'Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.'
                  )}
                />
              </div>
            </div>

            {/* pagination */}
            <div className="px-4 mt-2">
              <KTPagination
                currentPage={filter?.page + 1}
                rowCount={totalItems}
                rowsPerPage={filter?.limit}
                currentItemInPageCount={categoryList?.length}
                onChangePage={(newPage) => {
                  setFilter({ ...filter, page: parseInt(newPage) - 1 });
                }}
                onChangeRowsPerPage={(newRowsPerPage) => {
                  setFilter({ ...filter, limit: parseInt(newRowsPerPage), page: 0 });
                }}
                loading={false}
                color={KTPaginationColor.success}
                appendText="danh mục"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BannerCategoryScreen;
